import React from 'react'
import { urlConfig } from '../../../config/baseUrl';

const ChatAttachments = ({attachments}) => {
   const formatFileSize = (bytes) => {
     if (!bytes || bytes === 0) return "0 Bytes";

     const units = ["Bytes", "KB", "MB", "GB"];
     const i = Math.floor(Math.log(bytes) / Math.log(1024));

     return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 2)} ${units[i]}`;
   };
   const getFileIcon = (extension) => {
  switch (extension?.toLowerCase()) {
    case ".pdf":
      return "fa-file-pdf";

    case ".doc":
    case ".docx":
      return "fa-file-word";

    case ".xls":
    case ".xlsx":
      return "fa-file-excel";

    case ".zip":
      return "fa-file-zipper";

    default:
      return "fa-file";
  }
};
const openAttachment = (file) => {
  const url = `${urlConfig.imageBaseUrl}/${file.fileUrl}`;

  const previewExtensions = [".pdf", ".jpg", ".jpeg", ".png", ".gif", ".webp"];

  if (previewExtensions.includes(file.extension.toLowerCase())) {
    window.open(url, "_blank");
  } else {
    const link = document.createElement("a");
    link.href = url;
    link.download = file.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
  return (
    <div className="message-attachments">
      {attachments?.map((file) => (
        <div
          key={file.id}
          className="attachment-card"
          onClick={() => openAttachment(file)}
        >
          <i className={`fas ${getFileIcon(file.extension)}`}></i>

          <div className="attachment-info">
            <div className="attachment-name">{file.fileName}</div>

            <div className="attachment-size">
              {formatFileSize(file.fileSize)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ChatAttachments